import React from 'react';
import { Segment, Icon, Label, List, Button } from 'semantic-ui-react';

const AICoachingPanel = ({
  guideMessage,
  currentPhase,
  customerInsights,
  displayProduct,
  pinnedProduct,
  newSuggestion,
  handlePinProduct,
  handleUpdatePinToNew,
}) => {
  if (!guideMessage) {
    return null;
  }

  return (
    <Segment inverted style={{ backgroundColor: 'rgba(251, 191, 36, 0.9)', marginBottom: '1rem', backdropFilter: 'blur(4px)', color: 'black', zIndex: 0 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem', borderBottom: '1px solid rgba(0,0,0,0.2)', paddingBottom: '0.5rem' }}>
        <div style={{ fontSize: '0.85rem', color: '#000', textTransform: 'uppercase', fontWeight: 'bold' }}>
          <Icon name='lightbulb' /> AI Coaching
        </div>
        {currentPhase && (
          <Label color='black' size='small' horizontal>
            {currentPhase}
          </Label>
        )}
      </div>

      <div style={{ color: '#000', fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '1rem' }}>
        {guideMessage}
      </div>

      {(customerInsights.length > 0 || displayProduct) && (
        <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem', fontSize: '0.9rem', borderTop: '1px solid rgba(0,0,0,0.2)', paddingTop: '1rem' }}>
          {customerInsights.length > 0 && (
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 'bold', marginBottom: '0.25rem', opacity: 0.8 }}>Customer Notes</div>
              <List bulleted dense style={{ color: 'black' }}>
                {customerInsights.map((insight, idx) => (
                  <List.Item key={idx}>{insight}</List.Item>
                ))}
              </List>
            </div>
          )}

          {displayProduct && (
            <div style={{ flex: 1 }}>
              <div style={{ backgroundColor: 'rgba(255,255,255,0.2)', padding: '0.5rem', borderRadius: '4px', border: pinnedProduct ? '2px solid #000' : 'none' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.25rem' }}>
                  <div style={{ fontWeight: 'bold' }}>
                    <Icon name='tag' /> {displayProduct.name}
                    {pinnedProduct && <Icon name='pin' size='small' style={{ marginLeft: '0.25rem' }} />}
                  </div>
                  <Button
                    icon
                    size='mini'
                    compact
                    onClick={handlePinProduct}
                    style={{ backgroundColor: pinnedProduct ? '#000' : 'rgba(0,0,0,0.1)', color: pinnedProduct ? '#fff' : '#000' }}
                    title={pinnedProduct ? 'Unpin product' : 'Pin product'}
                  >
                    <Icon name={pinnedProduct ? 'pin' : 'pin'} />
                  </Button>
                </div>
                {displayProduct.specs && displayProduct.specs.length > 0 && (
                  <List dense style={{ color: 'black', paddingLeft: '0.5rem' }}>
                    {displayProduct.specs.map((spec, idx) => (
                      <List.Item key={idx}><Icon name='check' size='small' /> {spec}</List.Item>
                    ))}
                  </List>
                )}
              </div>

              {newSuggestion && (
                <div style={{ marginTop: '0.5rem', backgroundColor: 'rgba(59, 130, 246, 0.3)', padding: '0.5rem', borderRadius: '4px', border: '1px dashed #3B82F6' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.25rem' }}>
                    <div style={{ fontWeight: 'bold', fontSize: '0.85rem' }}>
                      <Icon name='idea' /> New: {newSuggestion.name}
                    </div>
                    <Button
                      icon
                      size='mini'
                      compact
                      color='blue'
                      onClick={handleUpdatePinToNew}
                      title='Switch to this product'
                    >
                      <Icon name='exchange' />
                    </Button>
                  </div>
                  {newSuggestion.specs && newSuggestion.specs.length > 0 && (
                    <List dense style={{ color: 'black', paddingLeft: '0.5rem', fontSize: '0.8rem' }}>
                      {newSuggestion.specs.slice(0, 3).map((spec, idx) => (
                        <List.Item key={idx}><Icon name='check' size='small' /> {spec}</List.Item>
                      ))}
                      {newSuggestion.specs.length > 3 && (
                        <List.Item style={{ opacity: 0.7 }}>+{newSuggestion.specs.length - 3} more...</List.Item>
                      )}
                    </List>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </Segment>
  );
};

export default AICoachingPanel;

